import React, { Component } from 'react';
import IllustrationLogo from '../IllustrationLogo';
import Thumbnail from '../Thumbnail';

class Home extends Component {
	UNSAFE_componentWillReceiveProps() {
		localStorage.setItem('lastPath', this.props.location.pathname);
	}

	render() {
		let elemClass = ['home-page'];
		let projects = [
			{
				id: 'dropracing',
				name: 'Drop Racing',
				description: 'Game',
				thumbnail: '__drop_racing.jpg',
				url: '/project/dropracing'
			},
			{
				id: 'respira',
				name: 'Respira',
				description: 'Lottie-web animation',
				thumbnail: '__respira.jpg',
				url: '/project/respira'
			},
			{
				id: 'illustrations',
				name: 'Illustrations',
				description: 'Shots',
				thumbnail: '__illustrations.gif',
				url: '/project/illustrations'
			},
			{
				id: 'branding',
				name: 'Branding',
				description: 'Logos',
				thumbnail: '__branding.gif',
				url: '/project/branding'
			},
			{
				id: 'freebies',
				name: 'Freebies',
				description: 'Icons, fonts and photos',
				thumbnail: '__freebies.jpg',
				url: '/project/freebies'
			},
			{
				id: 'sardinhas',
				name: 'Sardinhas',
				description: 'Digital painting',
				thumbnail: '__sardinhas.jpg',
				url: '/project/sardinhas'
			},
			// {
			// 	id: 'headbangingbird',
			// 	name: 'Headbanging Bird',
			// 	description: 'Game',
			// 	thumbnail: '__headbanging_bird.jpg',
			// 	url: '/project/headbangingbird'
			// },
			// {
			// 	id: 'fish',
			// 	name: 'Fish out of the bowl',
			// 	description: 'Comics',
			// 	thumbnail: '__fish.jpg',
			// 	url: '/project/fish'
			// },
			// {
			// 	id: 'fawna',
			// 	name: 'Fawna',
			// 	description: 'Lorem ipsum dolor sit amet',
			// 	thumbnail: '__fawna.jpg',
			// 	url: '/project/fawna'
			// },
			// {
			// 	id: 'photography',
			// 	name: 'Photography',
			// 	description: 'Lorem ipsum dolor sit amet',
			// 	thumbnail: '__photography.jpg',
			// 	url: '/project/photography'
			// }
		];

		return (
			<main className={elemClass.join(' ')} id="home-page">
				<section className="container">
					<div className="home-wrapper">
						<div className="home-wrapper__illustration">
							<IllustrationLogo />
							<h1 className="title-h1">
								<span className="step-1">Hello,</span>
								<br />
								<span className="step-2">
									i’m <span className="bold">Miguel</span>
									<br />
									<span className="bold step-3">Santos</span>
								</span>
							</h1>
						</div>
						<div className="home-wrapper__text">
							<div className="home-wrapper__text-content">

								<h1 className="title-h1">
									<span className="step-1">Hello,</span>
									<br />
									<span className="step-2">
										i’m <span className="bold">Miguel</span>
										<br />
										<span className="bold step-3">Santos</span>
									</span>
								</h1>
								<span className="title-caption step-4">
									I do graphic design, frontend and UX.<br></br>I'm also an indie game developer.
								</span>
								<br />
								<a className="button" href="mailto:miguelrdsantos@gmail.com">
									Contact-me
								</a>
							</div>
						</div>
					</div>
				</section>
				<section className="section--featured">
					<div className="container">
						<div className="thumbnail-wrapper grid">
							{projects.map((project, index) =>
								<Thumbnail key={index} project={project} size="4" id={index} />
							)}
						</div>
					</div>
				</section>
			</main>
		);
	}
}

export default Home;
